<nav class="navbar-main" aria-label="Main">
  <div class="content-container">
    <div class="navbar-header">
      <i class="header-qtime-logo"></i>
      Qtime App
    </div>
    <span class="header-pills">
      <span class="header-pill header-pill-net">.net</span>
      <span class="header-pill header-pill-version">v{{ version }}</span>
    </span>
    <div class="header-spacer"></div>

    <div *ngIf="showLogout" class="header-buttons">
      <a class="header-link" href="{{ qtimeAppPrinterUrl }}">
        To Qtime Printer (Wi-Fi) <i class="header-icon --arrow-up-right"></i>
      </a>
      <span class="header-divider" aria-hidden="true"></span>
      <button class="header-btn" type="button" (click)="logoutSession()">
        <i class="header-icon --logout"></i> Logout
      </button>
    </div>

    <div *ngIf="showLogout" class="header-burger-menu">
      <button
        #menuToggle
        class="header-btn header-btn-icon"
        type="button"
        aria-haspopup="menu"
        aria-controls="header-menu-list"
        [attr.aria-label]="menuOpen ? 'Close menu' : 'Menu'"
        [attr.aria-expanded]="menuOpen"
        (click)="menuOpen = !menuOpen"
      >
        <i class="header-icon" [ngClass]="menuOpen ? '--close' : '--menu'"></i>
      </button>
      <div *ngIf="menuOpen" class="header-dropdown-menu" id="header-menu-list" role="menu">
        <a class="header-menu-item header-menu-link" role="menuitem" href="{{ qtimeAppPrinterUrl }}">
          To Qtime Printer (Wi-Fi)
        </a>
        <div class="header-menu-sep"></div>
        <button class="header-menu-item" role="menuitem" type="button" (click)="menuOpen = false; logoutSession()">
          <i class="header-icon --logout"></i> Logout
        </button>
      </div>
    </div>
  </div>
</nav>
